import { useAtom } from 'jotai';

import { mainCurrenciesStore } from '../store/mainCurrenciesStore.js';

export function useMainCurrenciesState() {
  return useAtom(mainCurrenciesStore);
}
